import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

interface SkillInitialStateType {
  data: {
    overall: number,
    categories: [{
      category: string,
      skills: [{
        skillName: string,
        proficiency: number,
        description: string,
        experience: string,
        firstYearUsed: string,
        lastYearUsed: string,
        selfRating: string,
        synonyms: string,
        versions: [],
        whyIUsed: string,
      }],
      proficiency: number
    }]
  }
  loading: boolean
  status: number | null
  errorStatus: number | null
}

const initialState: SkillInitialStateType = {
  data: {
    overall: 0,
    categories: [{
      category: "",
      skills: [{
        skillName: "",
        proficiency: 0,
        description: "",
        experience: "",
        firstYearUsed: "",
        lastYearUsed: "",
        selfRating: "",
        synonyms: "",
        versions: [],
        whyIUsed: "",
      }],
      proficiency: 0
    }]
  },
  loading: false,
  status: null,
  errorStatus: null
}

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const getSkill = createAsyncThunk('SkillSlice/getSkill', async (_, thunkApi) => {
  try {
    const response = await axios.get(apiUrl + '/skills/rating')
    const data = await response.data.data
    return thunkApi.fulfillWithValue(data)
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status)
  }
})

const SkillSlice = createSlice({
  name: "SkillSlice",
  initialState,
  reducers: {
    getValue: (state, action) => {
      state.data = action.payload
    },
    resetValue: (state) => {
      state.data = { overall: 0, categories: [{ category: "", skills: [{ skillName: "", proficiency: 0, description: "", experience: "", firstYearUsed: "", lastYearUsed: "", selfRating: "", synonyms: "", versions: [], whyIUsed: "", }], proficiency: 0 }] }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getSkill.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getSkill.fulfilled, (state, action) => {
      state.data = action.payload
    })
    builder.addCase(getSkill.rejected, (state, action) => {
      state.errorStatus = action.payload as number
    })
    builder.addMatcher(isAnyOf(
      getSkill.fulfilled, getSkill.rejected), (state) => {
        state.loading = false
      })
  }
})

const SkillThunks = {
  getSkill,
}

export const SkillServices = {
  ...SkillThunks,
  actions: SkillSlice.actions,
}

const SkillReducer = SkillSlice.reducer
export default SkillReducer